export const servicios = {
    text1: "Liste des demandes de service",
    text2: "Demandes effectuées par vos clients",
    text3: "Liste des demandes",
    text4: "Toutes",
    text5: "En attente",
    text6: "Approuvées",
    text7: "Refusées",
    text8: "Payées",
    text9: "Service",
    text10: "Client",
    text11: "Téléphone",
    text12: "Créée",
    text13: "Statut",
    text14: "Voir la commande",
    text15: "Demande de service.",
    text16: "Données de la demande",
    text17: "Date de la demande :",
    text18: " à",
    text19: "Informations sur le service",
    text20: "Prix :",
    text21: "Prix par :",
    text22: "Catégorie :",
    text23: "Fournisseur :",
    text24: "Fournisseur :",
    text25: "Service interne",
    text26: "Informations sur le service",
    text27: "Service introuvable",
    text28: "Informations sur le demandeur",
    text29: "Téléphone :",
    text30: "E-mail :",
    text31: "Type de document :",
    text32: "Numéro de document :",
    text33: "Fermer",
    text34: "Refuser",
    text35: "Approuver",
    text36: "Confirmer le paiement",
    text37: "Refuser la demande",
    text38: "Approuver la demande",
    text39: "Confirmer le paiement du demandeur",
    text40: "Êtes-vous sûr de vouloir refuser la demande de service ?",
    text41: "Contactez le demandeur du service avant d'approuver la demande",
    text42: "En confirmant le paiement du demandeur, le processus sera terminé",
    text43: "Refuser",
    text44: "Approuver la demande",
    text45: "J'ai déjà confirmé le paiement",
    text46: "Annuler",
    text47: "Mise à jour réussie.",

    // New labels

    p1: `Aujourd'hui`,
    p2: `Service demandé`,
    p3: `Client`,
    p4: `Date de la demande`,
    p5: `Aucune demande de service n'a encore été effectuée`,
    p6: `Vous n'avez encore configuré aucun service.`,
    p7: `Configurez les services de votre hébergement pour que vos clients puissent faire des demandes`,
    p8: `Configurer un service`,
    p9: `Consultation`,
    p10: `Supprimer la demande de service`,
    p11: `Êtes-vous sûr ? Les données de la demande seront perdues`,
    p12: `Supprimer`,
    p13: `Demande de service supprimée avec succès`,
    p14: "Téléchargez jusqu'à 3 photos de votre service",
    p15: "Glissez-déposez pour télécharger des photos",
    p16: "...ou cliquez pour sélectionner des photos depuis votre ordinateur",
    p17: "Cliquez pour rechercher une image dans votre galerie"
};
